import { BrowserRouter, Route, Routes } from "react-router";
import "./App.css";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import HomePage from "./Pages/HomePage";
import AboutPage from "./Pages/AboutPage/AboutPage";
import ContactPage from "./Pages/ContactPage/ContactPage";
import GallaryPage from "./Pages/GallaryPage/GallaryPage";
import ServicesPage from "./Pages/ServicesPage/ServicesPage";
import CollectionsPage from "./Pages/CollectionsPage/CollectionsPage";
import BookingPage from "./Pages/BookingPage/BookingPage";
import ShopPage from "./Pages/ShopPage/ShopPage";
import CheckoutPage from "./Pages/CheckoutPage/CheckoutPage";
import ScrollToTop from "./Utilities/ScrollToTop";
import { CurrencyProvider } from "./Context/CurrencyContext";

function App() {
  return (
    <CurrencyProvider>
      <BrowserRouter>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<HomePage />} />
          <Route path="/about" exact element={<AboutPage />} />
          <Route path="/contact" exact element={<ContactPage />} />
          <Route path="/gallary" exact element={<GallaryPage />} />
          <Route path="/services" exact element={<ServicesPage />} />
          <Route path="/collections" exact element={<CollectionsPage />} />
          <Route path="/booking" exact element={<BookingPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </CurrencyProvider>
  );
}

export default App;
